import { render, staticRenderFns } from "./wantJob.vue?vue&type=template&id=b996ae7e&scoped=true"
import script from "./wantJob.vue?vue&type=script&lang=js"
export * from "./wantJob.vue?vue&type=script&lang=js"
import style0 from "./wantJob.vue?vue&type=style&index=0&id=b996ae7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b996ae7e",
  null
  
)

export default component.exports